import { render, staticRenderFns } from "./SubDashboardWrapper.vue?vue&type=template&id=1417e592&scoped=true&"
import script from "./SubDashboardWrapper.vue?vue&type=script&lang=ts&"
export * from "./SubDashboardWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./SubDashboardWrapper.vue?vue&type=style&index=0&id=1417e592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1417e592",
  null
  
)

export default component.exports